import * as React from 'react';
import { CoachSkillType } from '../../../types/coachSkillCertifications';
import classNames from 'classnames';
import './coachSkillLabels.module.scss';

const Label = ({ children, color }) => <div styleName={classNames('label', color)}>{children}</div>;

export const CoachSkillLabel = ({ type }) => {
    switch (type) {
        case CoachSkillType.MOKUMOKU_DESIGN:
            return <Label color={'green'}>デザイン</Label>;
        case CoachSkillType.MOKUMOKU_WRITING:
            return <Label color={'blue'}>ライター</Label>;
        case CoachSkillType.MOKUMOKU_MARKETING:
            return <Label color={'orange'}>マーケター</Label>;
    }
    return null;
};

export const CoachSkillLabels = ({ types }) => (
    <div styleName={'labels'}>{types.map((t) => <CoachSkillLabel key={t} type={t} />)}</div>
);
